import styled from 'styled-components'
import { Color } from 'root-constants'
import { Review } from 'components/Review'

export const StyledCustomerReviewsList = {
  Wrapper: styled.div``,
  Title: styled.div`
    position: relative;
    display: flex;
    align-items: center;
    min-height: 122px;
    margin-bottom: 16px;
    font-weight: 700;
    font-size: 28px;
    line-height: 38px;

    strong {
      color: ${Color.ORANGE};
      text-transform: uppercase;
    }
  `,
  TitleText: styled.div`
    max-width: 220px;
  `,
  Img: styled.img`
    position: absolute;
    right: 0;
    top: 0;
  `,
  Review: styled(Review)`
    background: #1f2435;
  `,
}
